import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Signal, ViewChild, ViewContainerRef, inject, ɵɵsetNgModuleScope, signal } from '@angular/core';
import { Router } from '@angular/router';
import { paragraphMapper } from 'src/app/models/paragraphs.model';
import { News, Service, Document, OrgUnit, Place, Event, Information } from 'src/app/models/searchresult.model';
import { DrupalService } from 'src/app/services/drupal.service';
export interface HorizontalBandConfig {
  identifier: string;
  headingText: string;
  showAllText: string;
  showAllRedirect: string;
  apiMethod: (params: any) => any;
  isEmpty?: boolean;
  color?: string;
  firstElement?: boolean;
}

@Component({
  selector: 'app-tag-layout',
  templateUrl: './tag-layout.component.html',
  styleUrls: ['./tag-layout.component.scss']
})


export class TagLayoutComponent implements OnInit {
  @Input() data: any; // This should have a property called paragraphs which is an array of paragraph data.
  @ViewChild('dynamicParagraph') dynamicParagraph: ViewContainerRef | any;

  loading: boolean = true;
  partials: any[] = [];
  breadcrumbs: any[] = [];
  argomentId!: string;
  drupalService = inject(DrupalService);
  router = inject(Router);
  getNews = (params: any) => this.drupalService.getNewsByTagId<News>(params);
  getServices = (params: any) => this.drupalService.getServicesByTagId<Service>(params);
  getDocuments = (params: any) => this.drupalService.getDocumentsByTagId<Document>(params);
  getOrgUnits = (params: any) => this.drupalService.getOrgUnitByTagId<OrgUnit>(params);
  getPlaces = (params: any) => this.drupalService.getPlacesByTagId<Place>(params);
  getEvents = (params: any) => this.drupalService.getEventsByTagId<Event>(params);
  getInformations = (params: any) => this.drupalService.getInformationsByTagId<Information>(params);

  horizontalBands: HorizontalBandConfig[] = [];

  constructor(dynamicParagraph: ViewContainerRef) {
    this.dynamicParagraph = dynamicParagraph;
    let currentUrl = this.router.url;
    this.drupalService.getContentByPath(currentUrl).subscribe(data => {
      this.argomentId = data?.data?.id;
      this.horizontalBands = [
        {
          identifier: this.argomentId,
          headingText: 'Novità',
          showAllText: 'Tutte le novità',
          showAllRedirect: '/novita',
          apiMethod: this.getNews,
          color: "grey",
          firstElement: false
        },

        {
          identifier: this.argomentId,
          headingText: 'Servizi',
          showAllText: 'Tutti i servizi',
          showAllRedirect: '/servizi',
          apiMethod: this.getServices,
          color: "white",
          firstElement: false
        },
        {
          identifier: this.argomentId,
          headingText: 'Documenti',
          showAllText: 'Tutti i documenti',
          showAllRedirect: '/documenti-e-dati',
          apiMethod: this.getDocuments,
          color: "grey",
          firstElement: false

        },
        // {
        //   identifier: this.argomentId,
        //   headingText: 'Amministrazione',
        //   showAllText: 'Tutta l\'amministrazione',
        //   showAllRedirect: '/amministrazione',
        //   apiMethod: this.getOrgUnits,
        //   color: "white",
        //   firstElement: false

        // },
        {
          identifier: this.argomentId,
          headingText: 'Luoghi',
          showAllText: 'Tutti i luoghi',
          showAllRedirect: '/vivere-il-comune/luoghi',
          apiMethod: this.getPlaces,
          color: "grey",
          firstElement: false

        },
        {
          identifier: this.argomentId,
          headingText: 'Eventi',
          showAllText: 'Tutti gli eventi',
          showAllRedirect: '/vivere-il-comune/eventi',
          apiMethod: this.getEvents,
          color: "white",
          firstElement: false
        },
        {
          identifier: this.argomentId,
          headingText: 'Informazioni',
          showAllText: 'Tutte le informazioni',
          showAllRedirect: '/informazioni',
          apiMethod: this.getInformations,
          color: "grey",
          firstElement: false
        }
      ];
    });
  }
  async ngOnInit() {

    this.partials = Array.isArray(this.data[this.data.type + '_partials']) ? this.data[this.data.type + '_partials'] : [];

    const viewContainerRef = this.dynamicParagraph; // Move this line outside the loop
    viewContainerRef.clear(); // Clear the view container once

    for (const paragraph of this.partials) {
      const paragraphType = paragraph.type;
      const paragraphData = paragraph;
      paragraph.related_tags = this.data.tag_related_tags;

      const module: any = await paragraphMapper(paragraphType);

      if (module && module.component) {
        ɵɵsetNgModuleScope(module, {
          declarations: [module.component],
          imports: [CommonModule],
          exports: [module.component]
        });

        const componentRef: any = viewContainerRef.createComponent(module.component);

        if (paragraphData) {
          componentRef.instance.data = paragraphData;
        }

        this.loading = false;
      } else {
        console.error(`Paragraph type ${paragraphType} not found`);
      }
    }

    /* this.loadData(); */

  }

  handleNoElements(headingText: string) {
    const band = this.horizontalBands.find(b => b.headingText === headingText);
    if (band) {
      band.isEmpty = true;
      this.updateBandColors();
      this.updateBandPadding();
    }
  }

  updateBandColors() {
    let nextColor = "grey";
    for (let band of this.horizontalBands) {
      if (!band.isEmpty) {
        band.color = nextColor;
        nextColor = nextColor == "grey" ? "white" : "grey";
      }
    }
  }
  updateBandPadding() {
    let firstFound = false;
    for (let band of this.horizontalBands) {
      if (!band.isEmpty && !firstFound) {
        band.firstElement = true;
        firstFound = true;
      } else {
        band.firstElement = false;
      }
    }
  }
}